import { useEffect } from 'react'
import { setFaviconBadge } from '@/lib/favicon-badge'

/**
 * Keep the browser-tab icon's red dot in sync with `show` for as long as the
 * caller is mounted, and clear it on unmount — logging out must not leave a
 * stale dot on the login tab.
 */
export function useFaviconBadge(show: boolean): void {
  useEffect(() => {
    setFaviconBadge(show)
  }, [show])

  useEffect(
    () => () => {
      setFaviconBadge(false)
    },
    [],
  )
}
